export default [
  '#4e79a7',
  '#ff9da7',
  '#af7aa1',
  '#76b7b2',
  '#bab0ab',
  '#9c755f',
  '#edc949',
  '#59a14f',
  '#e15759',
  '#f28e2c',
]
